/* eslint-disable react/jsx-no-target-blank */
import {
    faCode,
    faCodeCompare,
    faLaptopCode
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import "./About.css";

const About = () => {
  return (
    <div className="min-h-screen topBanner">
      <div className="h-80"></div>
      <div className=" bg-primary pb-32 pt-10">
        <h2 className="text-center text-4xl heading text-gray-800 py-5 font-semibold">
          Hi, I’m Rayhan. Nice to meet you.
        </h2>
        <div className="w-9/12 m-auto p-0">
          <p className="text-center text-2xl text-gray-800">
            Since beginning my journey as a web developer, last year i'm
            graduated from daffodil international university department of
            Software Engineering. I'm starting my carrier as Web developer from
            my passion, i like to create something new every day, last two year
            learning knowledge about frontend development technology HTML5,
            CSS3, Javascript, ES6, Bootstrap, Tailwind CSS, Frontend Framework
            ReactJS, etc.
          </p>
          <h3 className="py-5 text-gray-800 text-center text-4xl font-sans">My Working Area</h3>
        </div>
      </div>
      <div className="w-9/12 m-auto" style={{ marginTop: "-100px" }}>
        <div className="flex flex-row flex-wrap gap-5 justify-center items-center">
          <div>
            <div className="card rounded-none bg-gray-600">
              <div className="h-10 text-center">
                <FontAwesomeIcon
                  icon={faCode}
                  className="text-5xl py-4 text-primary"
                />
              </div>
              <div className="card-body">
                <h2 className="text-xl font-semibold font-sans text-center">
                  Figma, Sketch to HTML Convert
                </h2>
                <div className="card-actions justify-end">
                  <div className="badge badge-outline badge-sm">HTML5</div>
                  <div className="badge badge-outline badge-sm">CSS3</div>
                  <div className="badge badge-outline badge-sm">Bootstrap</div>
                  <div className="badge badge-outline badge-sm">Tailwind CSS</div>
                </div>
                <div className="card-actions justify-end"></div>
              </div>
            </div>
          </div>
          <div>
            <div className="card rounded-none bg-gray-600">
              <div className="h-10 text-center">
                <FontAwesomeIcon
                  icon={faCodeCompare}
                  className="text-5xl py-4 text-primary"
                />
              </div>
              <div className="card-body">
                <h2 className="text-xl font-semibold font-sans text-center">
                  Single Page Application(SPA)
                </h2>
                <div className="card-actions justify-end">
                  <div className="badge badge-outline badge-sm">ReactJS</div>
                  <div className="badge badge-outline badge-sm">React Context</div>
                  <div className="badge badge-outline badge-sm">Component Library</div>
                  <div className="badge badge-outline badge-sm">Firebase</div>
                </div>
                <div className="card-actions justify-end"></div>
              </div>
            </div>
          </div>
          <div>
            <div className="card rounded-none bg-gray-600">
              <div className="h-10 text-center">
                <FontAwesomeIcon
                  icon={faLaptopCode}
                  className="text-5xl py-4 text-primary"
                />
              </div>
              <div className="card-body">
                <h2 className="text-xl font-semibold font-sans text-center">
                  Full Stack Development
                </h2>
                <div className="card-actions justify-end">
                  <div className="badge badge-outline badge-sm">MongoDB</div>
                  <div className="badge badge-outline badge-sm">ExpressJS</div>
                  <div className="badge badge-outline badge-sm">ReactJS</div>
                  <div className="badge badge-outline badge-sm">NodeJS</div>
                </div>
                <div className="card-actions justify-end"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="my-10">
          <h1 className="text-center text-3xl font-sans font-medium">Connect with me</h1>
          <div className="py-10 flex justify-center items-center gap-5">
            <a href="https://www.linkedin.com/in/nmrayhan/" target="_blank" className="social-btn">Linkedin</a>
            <a href="https://www.facebook.com/nur.mohammad.rayhan.1997/" target="_blank" className="social-btn">Facebook</a>
            <a href="https://www.github.com/nmrayhan/" target="_blank" className="social-btn">Github</a>
          </div>
      </div>
    </div>
  );
};

export default About;
